import MD5 from 'crypto-js/md5'
import { _httpPost } from '@/service'
import { getAppParams } from '@/stores/app'

/** H5 独立上报关键消息链路，不通过 RN 桥接，也不阻塞业务。 */
export async function messageInfo(logTitle: string, fields: Record<string, unknown> = {}): Promise<void> {
  try {
    const { token, version, user_info } = getAppParams()
    const clientTime = Date.now()
    // 先提取错误字段，避免 AxiosError.toJSON 将请求头和 token 一起序列化。
    const error = fields.error as { code?: string; message?: string } | null | undefined
    const detail = JSON.stringify({
      timestamp: clientTime, source: 'H5', event: logTitle, userId: user_info?.userId, ...fields,
      error: error == null ? undefined : { code: error.code, message: error.message ?? String(error) },
    }, (_key, value) => typeof value === 'string' ? value.replace(/(https?:\/\/[^\s?#]+)[?#]\S*/g, '$1') : value)
    const data = {
      projectName: 'AI Bud', clientTime, level: 'info', logTitle, detail,
      others: {
        env: import.meta.env.MODE === 'production' ? 'prod' : 'dev',
        version, currentPage: window.location.pathname,
      },
    }
    if (token) {
      await _httpPost('/api/log/trace', data)
    } else {
      await _httpPost('/api/log/trace/touristMode', {
        ...data, signature: MD5(data.projectName + data.logTitle + data.clientTime).toString(),
      })
    }
  } catch {
    // 上报失败不提示、不重试，也不影响消息同步和音频操作。
  }
}
